import React, { useState, useEffect } from 'react';
import { HStack, PinInput } from '@chakra-ui/react';

// eslint-disable-next-line react/prop-types
export default function OtpInputField({ handleChangeOtp, n = 6 }) {
  const values = Array(n).fill('');

  const [otpValue, setOtpValue] = useState(values);

  useEffect(() => {
    const fullOtp = Object.values(otpValue).join('');
    handleChangeOtp(fullOtp);
  }, [otpValue]);

  const handleUpdate = (value, index) => {
    setOtpValue(prevState => {
      return {
        ...prevState,
        [index]: value,
      };
    });
  };

  const inputs = values.map((v, i) => {
    return (
      <PinInput.Input
        key={i}
        index={i}
        ml="10px"
        fontFamily="Helvetica"
        fontWeight="normal"
        onChange={e => {
          handleUpdate(e.target.value, i);
        }}
      />
    );
  });
  return (
    <HStack>
      <PinInput.Root otp size="lg">
        <PinInput.HiddenInput />
        <PinInput.Control>{inputs}</PinInput.Control>
      </PinInput.Root>
    </HStack>
  );
}
